
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>

    <div class="label blue-label">gift received</div>
    <div class="_10px-spacer"></div>
    <h3>You received a new chest!</h3>
    <img src="/assets/images/v2/jackpot/open-chest/chest.svg" height="160" class="chest" />
    <p>Inside you’ll find up to 10 keys. One lucky key will open the jackpot chest!</p>
    <a [routerLink]="['/', { outlets: { modal: 'open-chest' } }]" (click)="close()">
      <app-form-button class="primary full-width">Open</app-form-button>
    </a>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/chest-for-deposit-modal.component.ts.ModalChestForDepositComponent.html